export default __webpack_public_path__ + "static/media/loader5.04f14e8d.jpg";